import { TabType } from "../../Enums/EventEnums";
import { useCallback, useState } from "react";

export function useTabEditMode() {
  const [editModes, setEditModes] = useState<Record<TabType, boolean>>(
    {} as Record<TabType, boolean>
  );

  const toggleEditMode = useCallback((tabType: TabType) => {
    setEditModes((prev) => ({
      ...prev,
      [tabType]: !prev[tabType],
    }));
  }, []);

  const isEditMode = useCallback(
    (tabType: TabType): boolean => {
      return editModes[tabType] ?? false;
    },
    [editModes]
  );

  const setEditMode = useCallback((tabType: TabType, value: boolean) => {
    setEditModes((prev) => ({
      ...prev,
      [tabType]: value,
    }));
  }, []);

  return {
    editModes,
    isEditMode,
    toggleEditMode,
    setEditMode,
  };
}
